import React from 'react';
import constants from '../../common/constants';
import { Box, Container, Header } from '@amzn/awsui-components-core';
export default () => {
  return (
    <Box padding={{ top: 'xxl', horizontal: 'l' }}>
      <Container header={<Header variant="h3">{constants.PAGE_NOT_FOUND}</Header>}>
        <Box variant="p">{constants.PAGE_NOT_FOUND_MESSAGE}</Box>
      </Container>
    </Box>
  );
};
